import React from "react"
import { FaArrowLeft } from 'react-icons/fa'

import Button from "./Button"

import "./Modal.scss"

const Modal: React.FC<{ close: () => any }> = ({ close }) => {
    return <div className="modal">
        <div className="modal__wrapper">
            <button className="modal__close" onClick={close}>
                <FaArrowLeft />
                <p>Try with another account</p>
            </button>
            <div className="modal__content">
                <div className="modal__header">
                    <span>
                        <h2>It looks like you are on the Free Plan</h2>
                        <p>Integrations are part of Yac Teams.</p>
                        <p>Please upgrade your plan.</p>
                    </span>

                    <Button
                        label={'Get Yac for Teams'}
                        onClick={() => window.location.replace("https://app.yac.com/billing")}
                        className={'modal__button'}
                    />
                </div>
                <div className="modal__banner">
                    <div className="modal__pricing-current">
                        <h2>Your Plan</h2>
                        <ul>
                            <li>Unlimited Voice Messages</li>
                            <li>Public Sharing Links</li>
                            <li>Yac.com Profile</li>
                            <li>7 Day Message History</li>
                        </ul>
                    </div>
                    <div className="modal__pricing-upgrade">
                        <h2>Yac for Teams</h2>
                        <ul>
                            <li>Screen & Cam Recording</li>
                            <li>Team Management</li>
                            <li>Unlimited Message History</li>
                            <li>Transcription & Search</li>
                            <li>Slack & Zapier Integration</li>
                            <li>Groups & Channels</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div className="modal__bg" onClick={close}></div>
    </div>
}

export default Modal;